import React, { PureComponent } from 'react';
import Header from '../Header';
import styles from './UserHome.module.css';
import Explorer from '../Explorer';
import { Route, Switch } from 'react-router-dom';
import CreateEntity from '../CreateEntity';
import CreateMaterial from '../CreateMaterial';
import ViewEntity from '../ViewEntity';
import Listing from '../Listing';
import CreateRequest from '../CreateRequest';
import RequestView from '../RequestView';
import RequstList from '../RequstList';
import Dashboard from '../Dashboard';
import NewProject from '../NewProject';
import Home from '../Home';
import GenerateReport from '../GenerateReport';
import TagManager from '../TagManger';
import CollectionList from '../CollectionList';
import BatchUpload from '../BatchUpload';
import AssetUpload from '../AssetUpload';
import PreviewMaterial from '../PreviewMaterial';
import RenderList from '../RenderList';
import CreateRender from '../CreateRender';
import RenderView from '../RenderView';
import UserProfile from '../UserProfile';
import ManageUsers from '../ManagerUsers';
import SearchPage from '../SearchPage';
import AssetsRename from '../AssetsRename';
import UsageReport from '../UsageReport';

export default class UserHome extends PureComponent {
  render() {
    return (
      <div className={styles.container}>
        <Header />
        <div className={styles.content}>
          <Explorer />
          <Switch>
            {/** models */}
            <Route
              exact
              path="/models/new"
              component={CreateEntity('models', 'new')}
            />
            <Route
              exact
              path="/models/:id/upload"
              component={AssetUpload('models')}
            />
            <Route
              exact
              path="/models/:id/edit"
              component={CreateEntity('models', 'edit')}
            />
            <Route
              exact
              path="/models/:id/preview"
              component={PreviewMaterial('models')}
            />
            <Route exact path="/models/:id" component={ViewEntity('models')} />
            <Route exact path="/models" component={Listing('models')} />
            {/** materials */}
            <Route
              exact
              path="/materials/new"
              component={CreateMaterial('materials', 'new')}
            />
            <Route
              exact
              path="/materials/:id/upload"
              component={AssetUpload('materials')}
            />
            <Route
              exact
              path="/materials/:id/edit"
              component={CreateMaterial('materials', 'edit')}
            />
            <Route
              exact
              path="/materials/:id/preview"
              component={PreviewMaterial('materials')}
            />
            <Route
              exact
              path="/materials/:id"
              component={ViewEntity('materials')}
            />
            <Route exact path="/materials" component={Listing('materials')} />
            {/** scenes */}
            <Route
              exact
              path="/scenes/new"
              component={CreateEntity('scenes', 'new')}
            />
            <Route
              exact
              path="/scenes/:id/upload"
              component={AssetUpload('scenes')}
            />
            <Route
              exact
              path="/scenes/:id/preview"
              component={PreviewMaterial('scenes')}
            />
            <Route
              exact
              path="/scenes/:id/edit"
              component={CreateEntity('scenes', 'edit')}
            />
            <Route exact path="/scenes/:id" component={ViewEntity('scenes')} />
            <Route exact path="/scenes" component={Listing('scenes')} />
            <Route exact path="/search" component={SearchPage} />
            {/**  review requests */}
            <Route exact path="/requests/new" component={CreateRequest} />
            <Route exact path="/requests/:id" component={RequestView} />
            <Route exact path="/requests" component={RequstList} />
            <Route exact path="/dashboard" component={Dashboard} />
            <Route exact path="/projects/new" component={NewProject} />
            <Route exact path="/batchupload" component={BatchUpload} />
            {/** collections */}
            <Route exact path="/collections" component={CollectionList} />
            {/**renders */}
            <Route exact path="/renderings/new" component={CreateRender} />
            <Route exact path="/renderings/rename" component={AssetsRename} />
            <Route exact path="/renderings/:id" component={RenderView} />
            <Route
              exact
              path="/renderings/rename"
              component={AssetsRename}
            />
            <Route exact path="/renderings" component={RenderList} />
            {/**users */}
            <Route exact path="/users/profile" component={UserProfile} />
            <Route exact path="/users/notifications" component={UserProfile} />
            <Route exact path="/users/assignments" component={UserProfile} />
            {/** Admin */}
            <Route exact path="/admin/users" component={ManageUsers} />
            <Route exact path="/admin/reports" component={GenerateReport} />
            <Route exact path="/admin/usage" component={UsageReport} />
            <Route exact path="/admin/tags" component={TagManager} />
            <Route exact path="*" component={Home} />
          </Switch>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/UserHome/index.js